module.exports = __webpack_public_path__ + "media/images/pic/testimonials/monika-40e6e6489b450fbbc0b3241bc46d28f5.jpg";